import { Injectable } from "@angular/core";

export const cookieNames = {
  paymentResult: "payment-result",
};

@Injectable({
  providedIn: "root",
})
export class CookieService {
  constructor() {}

  setCookie(name: string, value: string, exdays?: number) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  }

  setCookieWithMinutes(name: string, value: string, minutes?: number) {
    var d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  }

  getCookie(name: string) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)"),
    );
    if (match) {
      return match[2];
    }
    return null;
  }

  getAllCookies() {
    return document.cookie;
  }

  checkCookie(name: string) {
    return Boolean(this.getCookie(name));
  }

  deleteCookie(name: string, path?: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${
      path ? path : "/"
    };`;
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
}
